module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    staticClass: "itemList",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "media-list": "",
      "id": "draft-list"
    }
  }, [_c('div', {
    staticClass: "showSmallScreenOnly"
  }, [_c('ul', _vm._l((_vm.drafts), function(draft) {
    return _c('li', {
      staticClass: "swipeout",
      style: ({
        background: _vm.getSeenStatusBackground('1')
      }),
      on: {
        "swipeout:deleted": function($event) {
          return _vm.deleteDraft(draft.idDraft)
        }
      }
    }, [_c('div', {
      staticClass: "item-content swipeout-content draftTaphold boxRequest",
      attrs: {
        "data-item": draft.idDraft,
        "data-complete": draft.isComplete
      },
      on: {
        "click": function($event) {
          return _vm.createPayments(draft)
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon list-icon icon-edit"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "font-size": "90%",
        "color": "orange"
      }
    }, [(draft.versionNumber > 1) ? _c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }) : _vm._e()]), _vm._v(" " + _vm._s(draft.draftName))]), _vm._v(" "), (draft.isComplete === '1' && draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)) ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('i', {
      staticClass: "fa fa-clock-o streammindBlueFont iconStatus"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n              ")]) : (draft.isComplete === '1' && draft.isValidated === '2') ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('span', {
      staticStyle: {
        "color": "orange"
      }
    }, [_c('i', {
      staticClass: "fa fa-clock-o iconStatus"
    })]), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n              ")]) : (draft.isComplete === '1' && draft.isValidated === '1') ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('i', {
      staticClass: "fa fa-check greenFont iconStatus"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n              ")]) : (draft.isComplete === '0' || draft.isComplete === '') ? _c('div', {
      staticClass: "item-subtitl"
    }, [_c('i', {
      staticClass: "fa fa-pencil redFont iconStatus"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n              ")]) : _vm._e()]), _vm._v(" "), ((draft.isValidated === '2' || draft.isValidated === '0') && draft.isValidator) ? _c('div', [_c('label', {
      staticStyle: {
        "margin-right": "30px",
        "margin-top": "10px",
        "font-size": "25px"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle streammindBlueFont"
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "swipeout-actions-right"
    }, [_c('a', {
      staticClass: "swipeout-delete",
      attrs: {
        "href": "#",
        "data-confirm": "You won't be able to recover this draft from MoneyRoad",
        "data-confirm-title": "Remove?",
        "data-close-on-cancel": "true"
      }
    }, [_vm._v("\n              Delete\n            ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "showLargeScreenOnly"
  }, _vm._l((_vm.drafts), function(draft) {
    return _c('li', {
      key: draft.idDraft,
      staticClass: "swipeout",
      style: ({
        background: _vm.getSeenStatusBackground('1')
      })
    }, [_c('div', {
      staticClass: "item-content draftTaphold boxRequest",
      attrs: {
        "data-item": draft.idDraft,
        "data-complete": draft.isComplete
      },
      on: {
        "click": function($event) {
          return _vm.createPayments(draft)
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon list-icon icon-edit"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner col-4"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('table', [_c('tr', [_c('td', {
      staticClass: "requestTitle"
    }, [_vm._v("\n                    " + _vm._s(draft.draftName) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', {
      staticClass: "versionSubTitle"
    }, [_c('span', {
      staticStyle: {
        "font-size": "90%",
        "color": "orange"
      }
    }, [(draft.versionNumber > 1) ? _c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }) : _vm._e()]), _vm._v("\n                Version " + _vm._s(draft.versionNumber) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-10"
    }, [_c('table', [_c('tr', [_c('td', {}, [(draft.isComplete === '1' && draft.isValidated === '1') ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('i', {
      staticClass: "fa fa-check iconStatus greenFont"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n                  ")]) : (draft.isComplete === '0' || draft.isComplete === '') ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('i', {
      staticClass: "fa fa-pencil iconStatus redFont"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n                  ")]) : (draft.isComplete === '1' && draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)) ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('i', {
      staticClass: "fa fa-clock-o iconStatus streammindBlueFont"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n                  ")]) : (draft.isComplete === '1' && draft.isValidated === '2') ? _c('div', {
      staticClass: "item-subtitle"
    }, [_c('i', {
      staticClass: "fa fa-clock-o iconStatus orangeFont"
    }), _vm._v(" " + _vm._s(_vm.getLabelStatus(draft)) + "\n                  ")]) : _vm._e()]), _vm._v(" "), ((draft.isValidated === '2' || draft.isValidated === '0') && draft.isValidator) ? _c('td', {
      staticClass: "statusLabel2"
    }, [_c('label', [_c('i', {
      staticClass: "fa fa-exclamation-circle iconStatus streammindBlueFont"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(_vm.$t('directPayments.vldtn_rqrd')))])])]) : _vm._e()])])]), _vm._v(" "), (false) ? _c('div', {
      staticClass: "item-media col-1"
    }, [_c('button', {
      staticClass: "button-swipe-out button-big button-bank-account boxRequest",
      attrs: {
        "onclick": "event.stopPropagation()"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDraftWebIHM(draft.idDraft)
        }
      }
    }, [_c('f7-icon', {
      staticClass: "button-delete",
      attrs: {
        "f7": "close_round"
      }
    })], 1)]) : _vm._e()])])
  }), 0)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-155a07be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-155a07be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/directPayments/DPDraftList.vue
// module id = 2341
// module chunks = 2